/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateDangerousGoodsDefinitionCommand } from '../model';
// @ts-ignore
import type { DangerousGoodsDefinitionDto } from '../model';
// @ts-ignore
import type { DangerousGoodsDefinitionDtoPaginatedList } from '../model';
// @ts-ignore
import type { UpdateDangerousGoodsDefinitionCommand } from '../model';
/**
 * DangerousGoodsDefinitionsApi - axios parameter creator
 */
export const DangerousGoodsDefinitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('_delete', 'id', id)
            const localVarPath = `/planning/api/DangerousGoodsDefinitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDangerousGoodsDefinitionCommand} [createDangerousGoodsDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (createDangerousGoodsDefinitionCommand?: CreateDangerousGoodsDefinitionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/DangerousGoodsDefinitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDangerousGoodsDefinitionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('get', 'id', id)
            const localVarPath = `/planning/api/DangerousGoodsDefinitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (page: number, pageSize: number, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('getAll', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('getAll', 'pageSize', pageSize)
            const localVarPath = `/planning/api/DangerousGoodsDefinitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['Page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (filter !== undefined) {
                localVarQueryParameter['Filter'] = filter;
            }

            if (includeCompleted !== undefined) {
                localVarQueryParameter['IncludeCompleted'] = includeCompleted;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['OrderBy'] = orderBy;
            }

            if (isDescending !== undefined) {
                localVarQueryParameter['IsDescending'] = isDescending;
            }

            if (from !== undefined) {
                localVarQueryParameter['From'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['To'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDangerousGoodsDefinitionCommand} [updateDangerousGoodsDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (updateDangerousGoodsDefinitionCommand?: UpdateDangerousGoodsDefinitionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/planning/api/DangerousGoodsDefinitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDangerousGoodsDefinitionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DangerousGoodsDefinitionsApi - functional programming interface
 */
export const DangerousGoodsDefinitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DangerousGoodsDefinitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async _delete(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsDefinitionsApi._delete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateDangerousGoodsDefinitionCommand} [createDangerousGoodsDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(createDangerousGoodsDefinitionCommand?: CreateDangerousGoodsDefinitionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DangerousGoodsDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(createDangerousGoodsDefinitionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsDefinitionsApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DangerousGoodsDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsDefinitionsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(page: number, pageSize: number, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DangerousGoodsDefinitionDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(page, pageSize, filter, includeCompleted, orderBy, isDescending, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsDefinitionsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDangerousGoodsDefinitionCommand} [updateDangerousGoodsDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(updateDangerousGoodsDefinitionCommand?: UpdateDangerousGoodsDefinitionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DangerousGoodsDefinitionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(updateDangerousGoodsDefinitionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsDefinitionsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DangerousGoodsDefinitionsApi - factory interface
 */
export const DangerousGoodsDefinitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DangerousGoodsDefinitionsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp._delete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDangerousGoodsDefinitionCommand} [createDangerousGoodsDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(createDangerousGoodsDefinitionCommand?: CreateDangerousGoodsDefinitionCommand, options?: RawAxiosRequestConfig): AxiosPromise<DangerousGoodsDefinitionDto> {
            return localVarFp.create(createDangerousGoodsDefinitionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: number, options?: RawAxiosRequestConfig): AxiosPromise<DangerousGoodsDefinitionDto> {
            return localVarFp.get(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {string} [filter] 
         * @param {boolean} [includeCompleted] 
         * @param {string} [orderBy] 
         * @param {boolean} [isDescending] 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(page: number, pageSize: number, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<DangerousGoodsDefinitionDtoPaginatedList> {
            return localVarFp.getAll(page, pageSize, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UpdateDangerousGoodsDefinitionCommand} [updateDangerousGoodsDefinitionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(updateDangerousGoodsDefinitionCommand?: UpdateDangerousGoodsDefinitionCommand, options?: RawAxiosRequestConfig): AxiosPromise<DangerousGoodsDefinitionDto> {
            return localVarFp.update(updateDangerousGoodsDefinitionCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DangerousGoodsDefinitionsApi - object-oriented interface
 */
export class DangerousGoodsDefinitionsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public _delete(id: number, options?: RawAxiosRequestConfig) {
        return DangerousGoodsDefinitionsApiFp(this.configuration)._delete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDangerousGoodsDefinitionCommand} [createDangerousGoodsDefinitionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(createDangerousGoodsDefinitionCommand?: CreateDangerousGoodsDefinitionCommand, options?: RawAxiosRequestConfig) {
        return DangerousGoodsDefinitionsApiFp(this.configuration).create(createDangerousGoodsDefinitionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public get(id: number, options?: RawAxiosRequestConfig) {
        return DangerousGoodsDefinitionsApiFp(this.configuration).get(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {string} [filter] 
     * @param {boolean} [includeCompleted] 
     * @param {string} [orderBy] 
     * @param {boolean} [isDescending] 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAll(page: number, pageSize: number, filter?: string, includeCompleted?: boolean, orderBy?: string, isDescending?: boolean, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return DangerousGoodsDefinitionsApiFp(this.configuration).getAll(page, pageSize, filter, includeCompleted, orderBy, isDescending, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UpdateDangerousGoodsDefinitionCommand} [updateDangerousGoodsDefinitionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public update(updateDangerousGoodsDefinitionCommand?: UpdateDangerousGoodsDefinitionCommand, options?: RawAxiosRequestConfig) {
        return DangerousGoodsDefinitionsApiFp(this.configuration).update(updateDangerousGoodsDefinitionCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

